import createReducer from './create-reducer';

const initial = {
  page: 1,
  perPageCard: 10,
  perPageTable: 20,
  layout: 'table-layout', //todo make this come form layout strategy ?
  search: '',
  tagsFacets: [],
  componentFacets: [],
  pagerInfo: {},
  sort: null
};

const reducers = {
  UPDATE_UNIQUEFIELDS_LAYOUT: (state, value) => {
    return {
      ...state,
      ...{
        pagerInfo: value.pagerInfo,
        layout: value.layout
      }
    };
  },
  UPDATE_UNIQUEFIELDS_PAGE: (state, value) => {
    return { ...state, ...{ page: value.page, pagerInfo: value.pagerInfo } };
  },
  UPDATE_UNIQUEFIELDS_PERPAGE: (state, value) => {
    return { ...state, ...{ perPage: value } };
  },
  UPDATE_UNIQUEFIELDS_SEARCH_TERM: (state, value) => {
    return { ...state, ...{ search: value, page: 1 } };
  },
  UPDATE_UNIQUEFIELDS_SEARCH_TAGS_FACETS: (state, value) => {
    return { ...state, ...{ tagsFacets: value, page: 1 } };
  },
  UPDATE_UNIQUEFIELDS_SEARCH_COMPONENT_FACETS: (state, value) => {
    return { ...state, ...{ componentFacets: value, page: 1 } };
  },
  UPDATE_UNIQUEFIELDS_SORT: (state, value) => {
    return { ...state, ...{ sort: value, page: 1 } };
  }
};

export default createReducer(initial, reducers);
